module.exports = __webpack_public_path__ + "static/media/penghu_pic1.197c0d30.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/penghu_pic1.jpg
 ** module id = 466
 ** module chunks = 0
 **/